import {
  ClassesIllustration,
  FactorIllustration,
  RoomIllustration,
  SubjectIllustration,
  TeacherIllustration,
  TransferQuotaTableIllustration,
} from '@bp/ui-components';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconMenu } from '../../../components/IconMenu/IconMenu';
import { IconMenuItem } from '../../../components/IconMenuItem/IconMenuItem';
import { Page } from '../../../components/Page/Page';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const DeputateSetupPage = memo(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const permissions = usePermissionChecker();

  return (
    <Page
      isForbidden={!permissions?.canReadDeputate()}
      title={`${t('deputate.title', { count: 2 })} ${t('deputate.setup').toLowerCase()}`}
    >
      <IconMenu headline={t('common.coreData')}>
        <IconMenuItem
          label={`${t('subject.title', { count: 2 })}/${t('subjectContainer.title', { count: 2 })}`}
          icon={<SubjectIllustration />}
          bubbleType={1}
          onClick={() => navigate(t('routes.subjects.slug'))}
        />
        <IconMenuItem
          label={t('persons.title', { count: 2 })}
          icon={<TeacherIllustration />}
          bubbleType={2}
          onClick={() => navigate(t('routes.teacher.slug'))}
        />
        <IconMenuItem
          label={t('classes.title', { count: 2 })}
          icon={<ClassesIllustration />}
          bubbleType={3}
          onClick={() => navigate(t('routes.classes.slug'))}
        />
        <IconMenuItem
          label={t('rooms.titleLong')}
          icon={<RoomIllustration />}
          bubbleType={4}
          onClick={() => navigate(t('routes.rooms.slug'))}
        />
      </IconMenu>
      <IconMenu headline={t('common.additionalData')} hasMarginTop>
        <IconMenuItem
          label={t('routes.factors.title')}
          icon={<FactorIllustration />}
          onClick={() => navigate(t('routes.factors.slug'))}
          bubbleType={9}
        />
        <IconMenuItem
          label={t('curriculum.title', { count: 2 })}
          icon={<TransferQuotaTableIllustration />}
          bubbleType={11}
          onClick={() => navigate(t('routes.curriculum.slug'))}
        />
      </IconMenu>
    </Page>
  );
});

DeputateSetupPage.displayName = 'DeputateSetupPage';
